'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _reactMixinSortable = require('./react-mixin-sortablejs/react-mixin-sortable');

var _reactMixinSortable2 = _interopRequireDefault(_reactMixinSortable);

var _lodashCompat = require('lodash-compat');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

/**
 * options参数参考https://github.com/RubaXa/Sortable
 */

var defaultOptions = {
  group: 'name',
  sort: false,
  delay: 0,
  disabled: false,
  animation: 150,
  preventOnFilter: true,
  ghostClass: 'mt-draggable__ghost',
  chosenClass: 'mt-draggable__chosen',
  dragClass: "mt-draggable__drag",
  forceFallback: false,
  fallbackClass: 'mt-draggable__fallback',
  fallbackOnBody: false,
  fallbackTolerance: 0,
  scroll: true,
  scrollSensitivity: 30,
  scrollSpeed: 10
};

var Draggable = (_temp = _class = function (_M$BaseComponent$Mixi) {
  _inherits(Draggable, _M$BaseComponent$Mixi);

  function Draggable(props) {
    _classCallCheck(this, Draggable);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Draggable).call(this, props));

    var options = props.options;
    var data = props.data;

    Object.assign(_this.state, {
      items: _this._format(data || [], props)
    });
    var eventOptions = {};
    'onStart onEnd onAdd onClone onFilter onChoose onUpdate onSort onRemove onMove'.split(' ').forEach(function (name) {
      eventOptions[name] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (name == 'onChoose') {
          //把选中的数据写在实例上
          var items = _this.state.items;

          _this._sortableInstance.data = items[args[0].oldIndex].value;
        }
        options[name] && options[name].apply(options, [_this._packData(args[0])].concat(args));
      };
    });
    _this.sortableOptions = Object.assign({}, defaultOptions, options, {
      ref: 'instance', //拖拽或放置功能的实例
      model: 'items', //渲染和传入SortableMixin的字段一致，因为SortableMixin内部会对这个状态进行处理
      dataIdAttr: 'data-id',
      stateHandler: '_handleNewSortableState'
    }, eventOptions);
    return _this;
  }

  _createClass(Draggable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var items = this.state.items;

      if (nextProps.hasOwnProperty('data')) {
        items = this._format(nextProps.data || [], nextProps);
      }
      this.setState({ items: items });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var prefixCls = _props.prefixCls;
      var format = _props.format;
      var itemClass = _props.itemClass;
      var disabled = _props.options.disabled;
      var items = this.state.items;

      return _react2.default.createElement(
        'ul',
        { ref: 'instance',
          className: this.classNames(prefixCls + '-draggable', _defineProperty({}, prefixCls + '-draggable--disabled', disabled)) },
        items.map(function (item, index) {
          var key = item.key;
          var value = item.value;

          var children = typeof format === 'function' ? format(value, key, index, items) : value;
          var props = { 'data-id': key, key: key };
          return children.type !== 'li' ? _react2.default.createElement('li', _extends({}, props, { children: children,
            className: _util2.default.classNames(prefixCls + '-draggable__item item-' + key, (0, _lodashCompat.isFunction)(itemClass) ? itemClass(value, key, index) : itemClass) })) : _react2.default.cloneElement(children, props);
        })
      );
    }

    /**
     * 格式化传入的数据为Object { key, value }
     * @param data
     * @param props
     * @private
     */

  }, {
    key: '_format',
    value: function _format(data, props) {
      var idField = props.idField;

      var ts = Date.now();
      return data.map(function (item, index) {
        //如果不设置idField，就以 [时间戳_索引] 为键值
        return {
          key: idField ? item[idField] : ts + '_' + index,
          value: item
        };
      });
    }
  }, {
    key: '_packData',
    value: function _packData(e) {
      var to = e.to;
      var from = e.from;
      var oldIndex = e.oldIndex;
      var newIndex = e.newIndex;

      var toSortable = this._searchInstance(to);
      var fromSortable = this._searchInstance(from);
      return {
        to: toSortable, //源Sortable
        from: fromSortable, //目标Sortable
        oldIndex: oldIndex,
        newIndex: newIndex,
        data: fromSortable.data };
    }
  }, {
    key: '_searchInstance',
    value: function _searchInstance(ele) {
      var k = Object.keys(ele).find(function (k) {
        return k.startsWith('Sortable');
      });
      return ele[k];
    }
  }, {
    key: '_handleNewSortableState',
    value: function _handleNewSortableState(state) {
      var _props2 = this.props;
      var onChange = _props2.onChange;
      var dataControled = _props2.dataControled;

      !dataControled && this.setState(state);
      if (onChange != null) {
        onChange(state.items.map(function (x) {
          return x.value;
        }));
      }
    }
  }, {
    key: 'getInstance',
    value: function getInstance() {
      return this._sortableInstance;
    }
  }, {
    key: 'setOption',
    value: function setOption(name, value) {
      Object.assign(this.sortableOptions, _defineProperty({}, name, value));
      this._sortableInstance.option(name, value);
    }
  }, {
    key: 'getOption',
    value: function getOption(name) {
      return this._sortableInstance.option(name);
    }
  }, {
    key: 'toArray',
    value: function toArray() {
      return this._sortableInstance.toArray();
    }
  }, {
    key: 'sort',
    value: function sort(order) {
      var items = this.state.items;

      var map = {};
      items.forEach(function (i) {
        map[i.key] = i;
      });
      var newItems = order.map(function (o) {
        return map[o];
      });
      this.setState({ items: newItems });
      this._sortableInstance.sort(order);
    }
  }]);

  return Draggable;
}(_util2.default.BaseComponent.Mixin(_reactMixinSortable2.default)), _class.propTypes = {
  prefixCls: _propTypes2.default.string,
  data: _propTypes2.default.array,
  dataControled: _propTypes2.default.bool,
  options: _propTypes2.default.shape({
    group: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
      name: _propTypes2.default.string,
      pull: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['clone']), _propTypes2.default.func]),
      put: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.func]),
      revertClone: _propTypes2.default.bool
    })]),
    sort: _propTypes2.default.bool,
    delay: _propTypes2.default.number,
    disabled: _propTypes2.default.bool,
    animation: _propTypes2.default.number,
    handle: _propTypes2.default.string,
    filter: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    preventOnFilter: _propTypes2.default.bool,
    ghostClass: _propTypes2.default.string,
    chosenClass: _propTypes2.default.string,
    dragClass: _propTypes2.default.string,

    scroll: _propTypes2.default.bool,
    scrollFn: _propTypes2.default.func,
    scrollSensitivity: _propTypes2.default.number,
    scrollSpeed: _propTypes2.default.number,

    forceFallback: _propTypes2.default.bool,
    fallbackClass: _propTypes2.default.string,
    fallbackOnBody: _propTypes2.default.bool,
    fallbackTolerance: _propTypes2.default.number,

    setData: _propTypes2.default.func,
    onStart: _propTypes2.default.func,
    onEnd: _propTypes2.default.func,
    onAdd: _propTypes2.default.func,
    onClone: _propTypes2.default.func,
    onFilter: _propTypes2.default.func,
    onChoose: _propTypes2.default.func,
    onSort: _propTypes2.default.func,
    onRemove: _propTypes2.default.func,
    onMove: _propTypes2.default.func
  }),
  format: _propTypes2.default.func,
  idField: _propTypes2.default.string,
  itemClass: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
}, _class.defaultProps = {
  prefixCls: 'mt',
  options: {},
  dataControled: false,
  format: null,
  idField: '',
  itemClass: ''
}, _temp);
exports.default = Draggable;